import { ApiParameters } from "./api-parameters";
import { ApiPostRequest } from "./api-post-request";

export class NetaxeptRegisterPaymentRequest extends ApiPostRequest
{
    public constructor(orderId: number, description: string, context: string, mobilePay: boolean, webapiBasepath: string)
    {
        var payload = {
            orderId,
            description,
            context,
            mobilePay
        };
        
        super('nets/netaxept/registerpayment', new ApiParameters(), null, payload, webapiBasepath);
    }
}
